import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Form,
  List,
  Card,
  Button,
  Radio,
  Checkbox,
  Switch,
  message,
  Spin,
  Affix,
} from 'antd';
import _ from 'lodash';
import $ from 'jquery';
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import qs from 'query-string';
import InfiniteScroll from 'react-infinite-scroller';
import { genFormItemAtrribute } from 'libs/FormHelper';
import { RadioControl, CheckboxControl } from '@wordpress/components';
import { withState } from '@wordpress/compose';
import bannerImage from 'assets/img/banner/banner-catalog.png';
import { __ } from '@wordpress/i18n';

const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [
    {
      name: '品牌 #1',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/48859859abcf9248f23d4f6202efcf5f.jpg",
    },
    {
      name: '品牌 #2',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/251b9bce1f9a454ae691944ea9396e31.jpg",
    },
    {
      name: '品牌 #3',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/f63176e067072961ddd5a17e7ecb61fe.jpg"
    },
    {
      name: '品牌 #4',
      // "logo_url": "http://cec.syscom.tw:8880/uploads/252716bd6a210aa82c3a09c2a62833e9.jpg",
    },
  ],
};
const VC_CONFIG = _.get(window, 'VC_CONFIG');
// 前端頁面
export default class CatalogueInfoPos extends Component {
  state = {
    catalogueInfo: {
      images: [],
    },
    data: [],
    loading: false,
    hasMore: true,
  };
  componentDidMount() {
    this.loadData();
    this.GTM();
  }
  GTM = () => {
    var dataLayer = window.dataLayer || [];
    $(document).on('click', '#pdf', function() {
      var $text = $(this).attr('alt');
      dataLayer.push({
        event: 'catalogue_pdf',
        item: $text,
      });
    });
  };
  // 抓取頁面資訊
  loadData = () => {
    const search = _.get(window, 'location.search');

    const queryParams = qs.parse(search);

    const id = queryParams.id;

    console.log('bb', queryParams);
    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/v1/catalogues/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/catalogues');
        return;
      }
      this.setState({ catalogueInfo: data });
      this.handleInfiniteOnLoad();
    });
  };
  handleInfiniteOnLoad = (page) => {
    const catalogueInfo = _.get(this.state, 'catalogueInfo');

    this.setState({ loading: true });

    setTimeout(() => {
      const data = _.get(this, 'state.data', []);
      const newData = _.slice(
        _.get(catalogueInfo, 'images'),
        0,
        data.length + 1
      );
      console.log('handleInfiniteOnLoad', page, data, newData);
      this.setState({
        loading: false,
        data: newData,
        hasMore: data.length < newData.length,
      });
    }, 100);
  };

  render() {
    const { catalogueInfo = {} } = this.state;
    const catalogues = _.get(this, 'state.listInfo.rows', []);
    const options = _.get(this, 'props.app.options', {});
    const category_ids = _.get(this.props, 'category_ids', []);
    const catalogue_categories = _.filter(
      _.get(options, 'catalogue_categories', []),
      (category) => category_ids.indexOf(category.id) !== -1
    );
    const selectedCategoryId = _.get(
      this,
      'state.selectedCategoryId',
      _.get(catalogue_categories, '0.id')
    );
    const pdf = _.get(catalogueInfo, 'pdfs.0');
    const urlQuery = AppHelper.getURLQuery();
    const isKiosk = urlQuery.view;
    return (
      <main class='bg-light'>
        {isKiosk && (
          <Affix offsetTop={30}>
            <Button
              style={{
                display: 'inline-flex',
                fontSize: '30px',
                color: 'white',
                borderRadius: '20px',
                backgroundColor: '#08c',
                height: '60px',
                width: '140px',
                top: '20px',
                left: '40px',
              }}
              onClick={() => window.history.back()}
            >
              <ArrowLeftOutlined
                style={{ fontSize: '40px', color: 'white', width: '70px' }}
              />
              返回
            </Button>
          </Affix>
        )}
        <div class='container'>
          {!isKiosk && (
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a href={`${VC_CONFIG.INDEX_URL}`}>
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a href='#' onClick={(e) => e.preventDefault()}>
                      {__('促銷目錄', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {catalogueInfo.category_id == 40 && (
                    <li class='breadcrumb-item'>
                      <a href={`${VC_CONFIG.INDEX_URL}/catalogues-corrections`}>
                        {__('目錄更正公告', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  {catalogueInfo.category_id == 41 && (
                    <li class='breadcrumb-item'>
                      <a
                        href={`${
                          VC_CONFIG.INDEX_URL
                        }/catalogues-preorderitemrules`}
                      >
                        {__('預購目錄應記載事項', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  {catalogueInfo.category_id != (40 || 41) && (
                    <li class='breadcrumb-item'>
                      <a href={`${VC_CONFIG.INDEX_URL}/catalogues`}>
                        {__('全部促銷目錄', 'cec-plugin-stores')}
                      </a>
                    </li>
                  )}
                  <li
                    class='breadcrumb-item active'
                    aria-current='page'
                    id='name'
                  >
                    {catalogueInfo.name}
                  </li>
                </ol>
              </nav>
            </div>
          )}

          <section class='pt-md-5'>
            {!isKiosk && pdf && (
              <a id='pdf' alt={catalogueInfo.name} href={pdf} target='_blank'>
                {' '}
                {__('PDF下載', 'cec-plugin-stores')}
              </a>
            )}
            <InfiniteScroll
              initialLoad={true}
              pageStart={0}
              loadMore={this.handleInfiniteOnLoad}
              hasMore={!this.state.loading && this.state.hasMore}
              // useWindow={false}
            >
              <div align='center'>
                <List
                  grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 1,
                    xxl: 1,
                  }}
                  dataSource={this.state.data}
                  renderItem={(image, idx) => (
                    <List.Item key={idx}>
                      <img
                        align='center'
                        src={image.replace('mppuni-prosperity', 'wwwuni-prosperity')}
                        alt='目錄'
                        style={{ width: '100%' }}
                      />
                    </List.Item>
                  )}
                >
                  {this.state.loading && this.state.hasMore && (
                    <div className='demo-loading-container'>
                      <Spin />
                    </div>
                  )}
                </List>
              </div>
            </InfiniteScroll>
          </section>
        </div>
      </main>
    );
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 };
export class CatalogueInfoPosEditor extends Component {
  formRef = React.createRef();
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  };
  componentDidMount() {
    AppHelper.updateConfig();
  }
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id');

    if (!id) return;

    this.setState({ isFetchData: true });
    whttp.get(API_HOST + `/api/v1/catalogues/${id}`, null, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/catalogues');
        return;
      }

      this.fillData(data);
    });
  };
  render() {
    const listInfo = this.state.listInfo;
    const options = _.get(this, 'props.app.options', {});
    console.log('editor', this.props);

    return (
      <div className='vu-blocks-editor'>
        <h2>促銷目錄內容</h2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/catalogues/catalogue-info-pos.js